import { useState, useEffect, useCallback, useMemo } from "react";
import { useProjectApi } from "../../../hooks/useProjectApi";
import { useProjectResorceMappingApi } from "../../../hooks/useProjectResource";
import { useResourceApi } from "../../../hooks/useResourceApi";
import { useRoleApi } from "../../../hooks/useRoleApi";
import { useParams } from "react-router-dom";
import { useBusinessUnitApi } from "../../../hooks/useBusinessUnitApi";

export const useAllProjectResorceMappingsViewModel = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const id = useParams()?.id;
  const {
    getProjects,
    cacheOperations: { readProjects, writeProjects },
  } = useProjectApi();

  const {
    getRoles,
    cacheOperations: { readRoles, writeRoles },
  } = useRoleApi();

  const {
    getResources,
    cacheOperations: { readResources, writeResources },
  } = useResourceApi();

  const {
    getProjectResorceMappings,
    createProjectResorceMapping: apiCreateProjectResorceMapping,
    updateProjectResorceMapping: apiUpdateProjectResorceMapping,
    deleteProjectResorceMapping,
    getProjectResorceMappingsByProjectId,
    cacheOperations: {
      readProjectResorceMappings,
      writeProjectResorceMappings,
    },
  } = useProjectResorceMappingApi();

  const {
    getBusinessUnits,
    cacheOperations: { readBusinessUnits, writeBusinessUnits },
  } = useBusinessUnitApi();

  const getBusinessUnitName = useMemo(
    () => (businessUnitId) => {
      const businessUnits = readBusinessUnits();

      console.log("businessUnits", businessUnits);
      console.log("businessUnitId", businessUnitId);

      const businessUnit = businessUnits.find(
        (bu) => bu.business_unit_id.toString() === businessUnitId?.toString()
      );

      return businessUnit?.business_unit_name || "Unknown";
    },
    [readBusinessUnits]
  );

  const fetchData = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    try {
      const [
        projectsResult,
        resourcesResult,
        projectResourceMappingsResult,
        rolesResult,
        businessUnitResult,
      ] = await Promise.all([
        getProjects(),
        getResources(),
        id
          ? getProjectResorceMappingsByProjectId(id)
          : getProjectResorceMappings(),
        getRoles(),
        getBusinessUnits(),
      ]);

      if (
        !projectsResult.success ||
        !resourcesResult.success ||
        !projectResourceMappingsResult.success ||
        !businessUnitResult.success
      ) {
        throw new Error("Failed to fetch required data");
      }
      writeProjects(projectsResult.data);
      writeResources(resourcesResult.data);
      writeRoles(rolesResult.data);
      writeProjectResorceMappings(projectResourceMappingsResult.data);
      writeBusinessUnits(businessUnitResult.data);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  }, [
    getProjects,
    getResources,
    getProjectResorceMappings,
    writeProjects,
    writeProjectResorceMappings,
    writeResources,
    loading,
  ]);

  useEffect(() => {
    fetchData();
  }, []);

  const handleCreateProjectResourceMapping = useCallback(
    async (formData) => {
      try {
        const result = await apiCreateProjectResorceMapping(formData);
        if (result.success) {
          return { success: true };
        }
        throw new Error(
          result.error || "Failed to create project resource mapping"
        );
      } catch (error) {
        console.error("Error creating  project resource mapping:", error);
        throw new Error(error.message);
      }
    },
    [apiCreateProjectResorceMapping, fetchData]
  );

  const handleUpdateProjectResourceMapping = useCallback(
    async (projectResourceMapping, formData) => {
      try {
        const result = await apiUpdateProjectResorceMapping(
          projectResourceMapping.project_resource_mapping_id,
          formData
        );
        if (result.success) {
          await fetchData();
          return { success: true };
        }
        throw new Error(
          result.error || "Failed to update project resource mapping"
        );
      } catch (error) {
        console.error("Error updating project resource mapping:", error);
        throw new Error(error.message);
      }
    },
    [apiUpdateProjectResorceMapping, fetchData]
  );

  const handleDelete = useCallback(
    async (projectResourceMapping) => {
      console.log("projectResourceMapping", projectResourceMapping);
      try {
        const result = await deleteProjectResorceMapping(
          projectResourceMapping.project_resource_mapping_id
        );
        if (result.success) {
          await fetchData();
        } else {
          // setError(result.error);
          throw new Error(result.error);
        }
      } catch (err) {
        console.log("errrr", err.message);
        // setError(err.message);

        throw new Error(err);
      }
    },
    [deleteProjectResorceMapping, fetchData]
  );
  const getResourceName = useMemo(
    () => (resourceId) => {
      const resources = readResources();
      console.log("1111333", resources, resourceId);
      const resource = resources.find(
        (resorc) => resorc.resource_id.toString() === resourceId?.toString()
      );

      return `${resource?.first_name} ${resource?.last_name}` || "Unknown";
    },
    [readResources]
  );

  const getResourceFullName = useMemo(
    () => (resourceId) => {
      const resources = readResources();
      console.log("1111333", resources, resourceId);
      const resource = resources.find(
        (resorc) => resorc.resource_id.toString() === resourceId?.toString()
      );

      return resource
        ? `${resource?.first_name} ${resource?.last_name}`
        : "Unknown";
    },
    [readResources]
  );

  const getProjectName = useMemo(
    () => (projectId) => {
      const projects = readProjects();

      const project = projects.find(
        (projct) => projct.project_id.toString() === projectId?.toString()
      );

      return project?.project_name || "Unknown";
    },
    [readProjects]
  );

  const getRoleName = useMemo(
    () => (roleId) => {
      const roles = readRoles();

      const role = roles.find(
        (rol) => rol.role_id.toString() === roleId?.toString()
      );
      return role?.role_name || "Unknown";
    },
    [readRoles]
  );

  return {
    projectResourceMappings: readProjectResorceMappings(),
    resources: readResources(),
    projects: readProjects(),
    roles: readRoles().filter(
      (e) =>
        e.is_project === true &&
        e.role_id != process.env.REACT_APP_PM_ROLE_ID &&
        e.role_id != process.env.REACT_APP_PO_ROLE_ID
    ),
    loading,
    error,
    getResourceName,
    getResourceFullName,
    getProjectName,
    getRoleName,
    getBusinessUnitName,
    createProjectResourceMapping: handleCreateProjectResourceMapping,
    updateProjectResourceMapping: handleUpdateProjectResourceMapping,
    handleDelete,
    refetch: fetchData,
  };
};
